<template>
    <div class="sidebar" style="width: initial;">
      <br /><br />
      <h6 class="mt-3 ml-3">Explore with Pickiddo</h6>
   
      <br />
      <CCard class="custom-card-warning mt-2 m-2" style="min-height: 153px;">
              <CRow>
                <div style="width: 50%" class="float-left">
                  <h3
                    style="text-align: left"
                    class="sub-title-header2 mt-3 ml-4 mb-2"
                  >
                  <strong> Redeem Rewards</strong><br />
                  </h3>
                    <label class="sub-title-card2 ml-4" style="margin-bottom: 20px;">
                      Claim Reward Points and enjoy more discount with Pickiddo
                    </label>
                    <CButton color="info" class="custom-header-btn ml-4" @click="GoToRedeem()">
                      Redeem Now</CButton
                    >
                  
                </div>
                <div style="width: 50%" class="float-right">
                  <img
                    style="
                      max-width: 100%;
                      right: 0;
                      position: absolute;
                      bottom: 0;
                      height: 150px;
                    "
                    src="../assets/img/icon/reward.svg"
                  />
                </div>
              </CRow>
            </CCard>
      <CCard class="custom-card-warning m-2">
                  <CRow>
                    <div style="width: 70%" class="float-left">
                      <h3 class="sub-title-header ml-4 mt-4 mb-4" style="text-align: left; color:#000A2C; font-weight: 600;">
                        Referral Program!<br />
                        <label class="sub-title-card" style="color:#000A2C;">
                          Refer your friends and family to use pickiddo and to receive awesome rewards!
                        </label>
                        <CButton color="info" class="custom-header-btn-blue mt-3">
                          Redeem Now
                        </CButton>
                      </h3>
                    </div>
                    <div style="width: 30%" class="float-right">
                      <img src="../assets/img/icon/referprogrammer.svg" style="
                        max-width: 100%;
                        right: 0;
                        position: absolute;
                        bottom: 0;"
                      />
                    </div>
                  </CRow>
                </CCard>

               
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        sidebarItems: [
          { id: 1, title: 'Home', path: '/ExistingUser' },
          { id: 2, title: 'Class', path: '/about' },
          { id: 3, title: 'Tutor', path: '/services' },
          { id: 4, title: 'Package', path: '/contact' },
          { id: 5, title: 'Profile', path: '/contact' }
        ],
        user: {},
        studentProfileAuthorize: "",
        activeMenuItem: ''
      };
    },
    async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetAuthorizeProfile(this.user.id);
            this.GetListChild(this.user.id);
            this.GetParentDetail(this.user.id);
            this.GetNews();
            this.GetTutorRating();
          }
        });
    },

    GetAuthorizeProfile() {
      this.$API
        .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentProfileAuthorize = response.data;
            this.photoURL =
              "https://pickiddo.com" + this.studentProfileAuthorize;
          }
        });
    },
    GoHome() {
      this.activeMenuItem = 'home'; 
      this.$router.push("/ExistingUser");
      
    },
    GoProfile() {
  if (this.user.userType == "parent") {
    this.activeMenuItem = 'profile'; // Set active menu item to 'profile' for parent
    this.$router.push("/ParentProfile/Profile");
  } else {
    this.activeMenuItem = 'profile'; // Set active menu item to 'profile' for tutor
    this.$router.push("/Tutor/TutorProfile");
  }
},
    GoClass() {
      this.activeMenuItem = 'class'; 
      this.$router.push("/Class/ClassMain");
    
    },
    GoTutor() {
      this.activeMenuItem = 'tutor';
      this.$router.push("/FindTutor/FindTutorMainpage");
    },
    GoPackage() {
      this.activeMenuItem = 'package'; 
      this.$router.push("/SignInUserAffiliate");
    },
    GoNotification() {
      this.activeMenuItem = 'notification'; 
      this.$router.push("/Notification");
    },
    GoToRedeem() {
      this.$router.push("/Redeem/Parent");
    },
}
  };
  </script>
  
  <style scoped>
  .sidebar {
    width: 300px;
    background-color: #f0f0f0;
    margin-left:20px;
    border-radius:20px;
    height:90vh;
    margin:20px;
  }
  .active {
  color: blue; /* Apply blue color to the active menu item */
}
  
  .sidebar ul {
    list-style-type: none;
    padding: 0;
  }
  
  .sidebar li {
    padding: 10px;
  }
  
  .sidebar li:hover {
    background-color: #0085ff;
    color:#fff;
  }
  </style>
  